/* eslint-disable @typescript-eslint/naming-convention */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  CampaignUmbrellaDetailStateType,
  SetCampaignChildsPayloadActionType,
  SetGroupedCampaignChildsPayloadActionType,
  SetQueryPayloadActionType,
} from 'features/CampaignAndDiscount/@types/campaignUmbrellaDetail'

export const SLICE_NAME = 'campaignUmbrellaDetail'

const initialState: CampaignUmbrellaDetailStateType = {
  isLoading: false,
  isDetailEditable: false,
  isDetailDeletable: false,
  query: {
    page_size: 20,
    vendor_name: '',
    cursor: '',
    isQuerySearchable: false,
    isInitialFetch: true,
  },
  detail: {
    campaign_theme: '',
    submission_date_start: '',
    submission_date_end: '',
    campaign_exposures: [],
    attachment: '',
    is_public_campaign: false,
    promo_criteria: {
      bmsm: {
        quota_min: 0,
        amount_sku_min: 0,
        tiers: [],
      },
      flash_sale: {
        discount_min: 0,
        amount_sku_min: 0,
        quota_min: 0,
      },
      single_discount: {
        discount_min: 0,
        amount_sku_min: 0,
        quota_min: 0,
      },
    },
    project_id: '',
    campaign_targets: [],
    l0_objectives: [],
    l1_objectives: [],
    vendor_quota: 0,
    campaign_period_start: '',
    campaign_period_end: '',

    buyer_targets: [],
    can_edit: '',
    campaign_objectives: [],
    submission_status: '',
    campaign_cluster_id: 0,
    month_year: '',
    package_id: '',
    brand_submission_batches: {
      '1': { close_date: '', status: '' },
      '2': { close_date: '', status: '' },
    },
  },
  campaignChilds: [],
  groupedCampaignChilds: [],
}

const campaignUmbrellaDetail = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setDetail: (state, action: PayloadAction<CampaignUmbrellaDetailStateType['detail']>) => {
      state.detail = action.payload
    },
    setCampaignChilds: (state, action: PayloadAction<SetCampaignChildsPayloadActionType>) => {
      const { value } = action.payload
      state.campaignChilds = value
    },
    setGroupedCampaignChilds: (
      state,
      action: PayloadAction<SetGroupedCampaignChildsPayloadActionType>,
    ) => {
      const { value } = action.payload
      state.groupedCampaignChilds = value
    },
    setQuery: (state, action: PayloadAction<SetQueryPayloadActionType>) => {
      state.query = { ...state.query, ...action.payload }
    },
    setIsDetailEditable: (state, action: PayloadAction<boolean>) => {
      state.isDetailEditable = action.payload
    },
    setIsDetailDeletable: (state, action: PayloadAction<boolean>) => {
      state.isDetailDeletable = action.payload
    },
  },
})

export const {
  setIsLoading,
  reset,
  setDetail,
  setCampaignChilds,
  setGroupedCampaignChilds,
  setQuery,
  setIsDetailEditable,
  setIsDetailDeletable,
} = campaignUmbrellaDetail.actions
export default campaignUmbrellaDetail.reducer
